/** Regulator-spec registry + output/config validation (PHASE3-CONTRACT §4). */
import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "./client";
import type {
  OutputValidationReport,
  SpecDetail,
  SpecSummary,
  ValidateConfigIn,
  ValidateOutputIn,
} from "./types";

export function useSpecs(query?: { q?: string; family?: string }) {
  return useQuery({
    queryKey: ["specs", query ?? {}],
    queryFn: async (): Promise<SpecSummary[]> => {
      const params: Record<string, string> = {};
      if (query?.q) params.q = query.q;
      if (query?.family) params.family = query.family;
      const { data } = await api.get<SpecSummary[]>("/specs", { params });
      return data;
    },
    staleTime: 5 * 60 * 1000,
  });
}

export function useSpec(id: string | undefined) {
  return useQuery({
    queryKey: ["spec", id],
    queryFn: async (): Promise<SpecDetail> => {
      const { data } = await api.get<SpecDetail>(`/specs/${encodeURIComponent(id as string)}`);
      return data;
    },
    enabled: !!id,
  });
}

export function useValidateOutput() {
  return useMutation({
    mutationFn: async (payload: ValidateOutputIn): Promise<OutputValidationReport> => {
      const { data } = await api.post<OutputValidationReport>("/validate/output", payload);
      return data;
    },
  });
}

export function useValidateConfig() {
  return useMutation({
    mutationFn: async (payload: ValidateConfigIn): Promise<OutputValidationReport> => {
      const { data } = await api.post<OutputValidationReport>("/validate/config", payload);
      return data;
    },
  });
}
